import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n';
import './LanguageToggle.css';

const LABELS: Record<SupportedLanguage, string> = { ar: 'AR', en: 'EN' };

/** Flips direction + all strings instantly, no reload — 08-staff-ux.md §2. */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage as SupportedLanguage;

  return (
    <div className="fa-lang-toggle" role="group" aria-label={t('topbar.language')}>
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang}
          type="button"
          className="fa-lang-toggle__btn"
          aria-pressed={current === lang}
          onClick={() => void i18n.changeLanguage(lang)}
        >
          {LABELS[lang]}
        </button>
      ))}
    </div>
  );
}
